import { Login, ForgotPassword, ResetPassword } from '../Pages/User';
import Contact from '../Components/Contact/Contact';

export const mainPublicRoutesArr = [
    // {
    //   path: '/user',
    //   component: UserAuth,
    // },
    // {
    //   path: '/settings',
    //   component: Settings,
    // },
    {
        path: '/user/login',
        component: Login,
    },
    {
        path: '/user/forgot-password',
        component: ForgotPassword,
    },
    {
        path: '/user/reset-password',
        component: ResetPassword,
    },
    // {
    //   path: '/user/contact-us',
    //   component: Contact,
    // },
    {
        path: '/settings/contact-us',
        component: Contact,
    }
];